import apiClient from './client';

export interface SSOConfig {
  id?: string;
  organization_id?: string;
  protocol: 'saml' | 'oidc';
  domain: string;
  // SAML
  idp_entity_id?: string;
  idp_sso_url?: string;
  idp_certificate?: string;
  sp_entity_id?: string;
  // OIDC
  client_id?: string;
  client_secret?: string;
  discovery_url?: string;
  scopes?: string;
  // Common
  attribute_mapping?: { email: string; name: string };
  auto_provision?: boolean;
  default_role?: 'member' | 'admin';
  is_active?: boolean;
}

export interface SSOCheckResult {
  sso_enabled: boolean;
  protocol?: 'saml' | 'oidc';
  organization_id?: string;
  domain?: string;
}

export async function checkEmailSSO(email: string): Promise<SSOCheckResult> {
  const res = await apiClient.get('/api/sso/check', { params: { email } });
  return res.data;
}

export async function getSSOConfig(): Promise<SSOConfig | null> {
  const res = await apiClient.get('/api/sso/config/full');
  return res.data.config;
}

export async function saveSSOConfig(config: SSOConfig): Promise<SSOConfig> {
  const res = await apiClient.post('/api/sso/config', config);
  return res.data.config;
}

export async function deleteSSOConfig(): Promise<void> {
  await apiClient.delete('/api/sso/config');
}

export async function testSSOConfig(): Promise<{ success: boolean; message?: string; issues?: string[] }> {
  const res = await apiClient.post('/api/sso/test');
  return res.data;
}

/** Génère l'URL pour initier le flow SSO (SAML ou OIDC) */
export function getSSOInitiateURL(orgId: string): string {
  const base = process.env.REACT_APP_API_URL || 'http://localhost:5000';
  return `${base}/api/sso/initiate?org_id=${orgId}`;
}

/** Génère l'URL des métadonnées SP SAML */
export function getSAMLMetadataURL(orgId: string): string {
  const base = process.env.REACT_APP_API_URL || 'http://localhost:5000';
  return `${base}/api/sso/saml/metadata/${orgId}`;
}
